import React, {useCallback, useEffect, useRef, useState} from 'react';
import {DrawingCanvas} from '../DrawingCanvas';
import {ColorButton} from '../ColorButton';
import {ConfirmButton} from '../ConfirmButton';
import {Store} from "../../models/Store";
// 一時的に描画シェア機能をオフにする
import {StrokeButton} from "../StrokeButton";
import {Colors} from '../../models/Colors';
import './DrawingPage.scss';
import TitleImg from '../../images/drawing__title.png';
import frameImg from '../../images/drawing__frame.png';
import frameImgSp from '../../images/sp/drawing__frame.png';

//

export const DrawingPage = (props: {
    onDone: () => void;
}) => {

    //

    const canvasElementRef = useRef<HTMLCanvasElement>(null);
    const drawingCanvasRef = useRef<DrawingCanvas>(new DrawingCanvas(Colors[0]));
    useEffect(() => {

        const canvasElement = canvasElementRef.current!;
        const drawingCanvas = drawingCanvasRef.current;
        drawingCanvas.init(canvasElement);

        // 初期データ保存
        Store.smileRegister.add();

        //
        return () => {
            drawingCanvas.destroy();
        };
    }, []);

    //

    const [strokeWidth, setStrokeWidth] = useState(1);

    //

    const [colorIndex, setColorIndex] = useState(0);

    // 一時的に描画シェア機能をオフにする
    // const sharedSmilesContainerRef = useRef<SharedSmilesContainer>(new SharedSmilesContainer());
    // const sharedSmilesElementRef = useRef<HTMLDivElement>(null);
    // useEffect(() => {
        // const e = sharedSmilesElementRef.current!;
        // const c = sharedSmilesContainerRef.current;
        // c.initialize(e);
    // }, []);

    // callbask

    const onColorChange = useCallback((value: number, index: number) => {
        const drawingCanvas = drawingCanvasRef.current;
        drawingCanvas.setColor(value);
        setColorIndex(index);
    }, []);

    const onConfirmButtonClick = useCallback(() => {
        // const drawingCanvas = drawingCanvasRef.current;
        // const data = drawingCanvas.getData();
        props.onDone();
    }, [props]);

    const onWidthButtonClick = useCallback((value: number) => {
        const drawingCanvas = drawingCanvasRef.current;
        setStrokeWidth(value);
        drawingCanvas.setWidth(value);
    }, []);

    // render

    const buttons = [];
    for (let i = 0; i < Colors.length; i++) {
        buttons.push(
            <ColorButton index={i} key={i} color={Colors[i]} onColorChange={onColorChange}
                         selected={colorIndex === i}/>,
        );
    }

    return (
        <div className='drawing-page'>

            {/*一時的に描画シェア機能をオフにする*/}
            {/*<div className={'drawing-page__shared-container'} ref={sharedSmilesElementRef}></div>*/}

            <h1><Title/></h1>

            <div className={'drawing-page__position-fixer-mobile'}>

                <div className={'drawing-page__position-fixer-inner-mobile'}>

                    <div className={'drawing-page__position-fixer'}>
                        <div style={Store.isDeviceMobile ? {display: 'center', justifyContent: 'flex'} : {}}>
                            <div className="drawing-page__canvas-button-container">
                                <div className="drawing-page__canvas-container">
                                    <Frame mobile={Store.isDeviceMobile}/>
                                    <canvas ref={canvasElementRef}/>
                                </div>
                                <div className="drawing-page__color-button-container">
                                    {buttons}
                                </div>
                                <div className={'drawing-page__stroke-width-button-container'}>
                                    <StrokeButton id={1} onClick={onWidthButtonClick} strokeWidth={strokeWidth}/>
                                    <StrokeButton id={2} onClick={onWidthButtonClick} strokeWidth={strokeWidth}/>
                                    <StrokeButton id={3} onClick={onWidthButtonClick} strokeWidth={strokeWidth}/>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <div className={'drawing-page__confirm-button-wrapper'}>
                <ConfirmButton onClick={onConfirmButtonClick} mobile={Store.isDeviceMobile}/>
            </div>
        </div>
    );
};

const Title = () => {
    return <img src={TitleImg} alt="" width={487} height={80}/>;
};

const Frame = (props: { mobile: boolean }) => {
    return props.mobile ?
        (<img className='drawing-page__frame' src={frameImgSp} alt="" width={963 / 3} height={963 / 3}/>) :
        (<img className='drawing-page__frame' src={frameImg} alt="" width={612} height={612}/>);

};